import { render } from "./ongoing.vue?vue&type=template&id=1b86041a"
import script from "./ongoing.vue?vue&type=script&lang=js"
export * from "./ongoing.vue?vue&type=script&lang=js"

import "./ongoing.vue?vue&type=style&index=0&id=1b86041a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__